import { openAppDrawer } from "@client/utils/exclusiveDrawer";
import { Button } from "@sfc/ui";
import { ListChecksIcon } from "lucide-react";

/**
 * The app-bar button that opens the To Do rail.
 *
 * Split from the drawer itself because the app bar renders OUTSIDE the round
 * provider the rail's data lives in — the same split the Queue and General
 * Notes drawers use. The shared drawer store is the bridge.
 */
export function TodoDrawerTrigger() {
  return (
    <Button
      type="button"
      variant="nav"
      size="icon"
      title="To Do"
      aria-label="Open your to-do list for this round"
      onClick={() => openAppDrawer("todo")}
      className="rounded-full"
    >
      <ListChecksIcon className="size-5" />
    </Button>
  );
}
